import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const California = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/sushi' name='Калiфорнii'/>
            <main className={s.main}>
                <Product name='Каліфорнія з лососем' price='170 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, огірок, авокадо, лосось, кунжут'/>
                <Product name='Каліфорнія з вугрем' price='190 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, огірок, авокадо, вугор, кунжут'/>
                <Product name='Каліфорнія з тигровою креветкою' price='180 грн.' weight='250г./8шт.' info1='рис, норі, філаделфія, креветка, кунжут'/>
                <Product name='Каліфорнія Сезам' price='120 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, огірок, огірок, кунжут'/>
                <Product name='Каліфорнія з крабовою паличкою' price='150 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, крабова паличка, огірок, кунжут'/>
                <Product name='Каліфорнія екзотик з креветкою' price='200 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, креветка, ківі, кокосова стружка, чилі, унарі'/>
                <Product name='Екзотичний рол з лососем' price='200 грн.' weight='260г./8шт.' info1='рис, норі, філаделфія, лосось, авокадо, ананас, кокосова стружка, унарі'/>
            </main>
        </div>
    )
}

export default California;